import { billingSelector, loadedInitSelector } from "appredux/selectors";
import { useSelector } from "react-redux";
import useFormatting from "./useFormatting";

const useRemainingBalance = () => {
  const { currency } = useFormatting();
  const loadedInit = useSelector(loadedInitSelector);
  const billing = useSelector(billingSelector);
  const remainingBalance = billing?.balance || 0;

  const isShowWarnBalanceNotification =
    billing?.excluded || !loadedInit ? false : remainingBalance < 50000;
  const isChatRestricted =
    billing?.excluded || !loadedInit ? false : remainingBalance < 0;
  return {
    isShowWarnBalanceNotification,
    isChatRestricted,
    remainingBalance: currency(remainingBalance, { addonAfter: ",-" }),
  };
};

export default useRemainingBalance;
